import { EDocumentType, EQuestionaireQuestionType } from "@/domain/enums";
import { QuestionaireFormQuestionType } from "./dto/QuestionaireFormDTO";

export const DOCTYPE_NAMES: Record<EDocumentType, string> = {
    [EDocumentType.MEDICAL_RECORD]: "Prontuário",
    [EDocumentType.PRESCRIPTION]: "Receita"
};

export const QUESTION_TYPE_NAMES: Record<QuestionaireFormQuestionType, string> = {
    [EQuestionaireQuestionType.SINGLE_CHOICE]: "Escolha única",
    [EQuestionaireQuestionType.MULTIPLE_CHOICE]: "Múltipla escolha",
    [EQuestionaireQuestionType.RATING]: "Escala (1–5)",
    [EQuestionaireQuestionType.TEXT]: "Texto",
    "yes_no": "Sim / Não"
};

export const QUESTION_TYPE_ARRAY: { id: QuestionaireFormQuestionType; name: string }[] =
    Object.entries(QUESTION_TYPE_NAMES).map(([id, name]) => ({
        id: id as QuestionaireFormQuestionType,
        name,
    }));
